import { Chip } from "../../../../components/common/chip";
import type { ChipVariant } from "../../../../components/common/chip/chip";

type DisputeStatus =
  | "OPEN"
  | "UNDER_REVIEW"
  | "RESOLVED_REFUND"
  | "RESOLVED_REPLACEMENT"
  | "RESOLVED_OTHER"
  | "REJECTED";

const STATUS_VARIANT: Record<DisputeStatus, ChipVariant> = {
  OPEN: "inReview",
  UNDER_REVIEW: "underReview",
  RESOLVED_REFUND: "approved",
  RESOLVED_REPLACEMENT: "approved",
  RESOLVED_OTHER: "approved",
  REJECTED: "rejected",
};

const STATUS_LABEL: Record<DisputeStatus, string> = {
  OPEN: "Open",
  UNDER_REVIEW: "Under Review",
  RESOLVED_REFUND: "Resolved (Refund)",
  RESOLVED_REPLACEMENT: "Resolved (Replacement)",
  RESOLVED_OTHER: "Resolved",
  REJECTED: "Rejected",
};

interface DisputeStatusChipProps {
  status: string;
}

export function DisputeStatusChip({ status }: DisputeStatusChipProps) {
  const s = status as DisputeStatus;
  return (
    <Chip variant={STATUS_VARIANT[s] ?? "tertiary"}>
      {STATUS_LABEL[s] ?? status}
    </Chip>
  );
}

